export default __webpack_public_path__ + "static/media/dg-icon-active.77b970ed.svg";